export enum ToastStyle {
	WcPromotion2026 = 'wc2026-promotion',
	WcSpinInfo = 'wc2026-spin-info',
}